<template>
  <div style="margin-top: 10px;;">
    <b-tabs>
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("Orders") }}</strong>
        </template>
        <OrdersWaiting />
      </b-tab>
      <b-tab>
        <template #title>
          <strong style="font-weight: 500; color: black">{{ $t("Articles") }}</strong>
        </template>
        <ArticlesWaiting />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ArticlesWaiting from '@/components/InternalMovement/ArticlesWaiting.vue'
import OrdersWaiting from '@/components/InternalMovement/OrdersWaiting.vue'




export default {
  components: {
    ArticlesWaiting,
    OrdersWaiting,
  },
  methods: {
  },
}
</script>

  <style scoped>

  </style>
